import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuescroll from 'vuescroll'
import store from './vuex'
import './assets/scss/app.scss'
import './assets/scss/color.scss'
import './assets/scss/fonts.scss'
import './assets/scss/mp.scss'
import './assets/scss/base.scss'
import './assets/scss/animate.scss'
import './assets/scss/ui.scss'
import 'animate.css'
import atui from 'at-ui'
import 'at-ui-style'
// import instance from '@/api/config.js';
console.log(`
 * _______________#########_______________________ 
 * ______________############_____________________ 
 * ______________#############____________________ 
 * _____________##__###########___________________ 
 * ____________###__######_#####__________________ 
 * ____________###_#######___####_________________ 
 * ___________###__##########_####________________ 
 * __________####__###########_####_______________ 
 * ________#####___###########__#####_____________ 
 * _______######___###_########___#####___________ 
 * _______#####___###___########___######_________ 
 * ______######___###__###########___######_______ 
 * _____######___####_##############__######______ 
 * ____#######__#####################_#######_____ 
 * ____#######__##############################____ 
 * ___#######__######_#################_#######___ 
 * ___#######__######_######_#########___######___ 
 * ___#######____##__######___######_____######___ 
 * ___#######________######____#####_____#####____ 
 * ____######________#####_____#####_____####_____ 
 * _____#####________####______#####_____###______ 
 * ______#####______;###________###______#________ 
 * ________##_______####________####______________ 
 `);
 console.log('%c Coolui Scroll by wzs %c QQ:1003418012 %c github: %c https://github.com/wzs28150/coolui-scroller ', 'color: #fff; background:#41b883; padding:5px 0;', 'color: #fff; background: #35495e; padding:5px 0;', 'color: #fff; background:#41b883; padding:5px 0;', 'color: #fff; background: #fff; border:1px solid #35495e; padding:4px 0;');
Vue.config.productionTip = false
Vue.use(vuescroll)
Vue.use(atui)
new Vue({
	render: h => h(App),
	router,
	store
}).$mount('#app')
// instance.get('router.json').then(res => {
// 	router.options.routes = eval(res.data.nav);
	
// 	console.log(router);
// 	setTimeout(() => {
		
// 	}, 300);
// });